/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('DOMContentLoaded', function() {
    const termsOfServiceCheckbox = document.querySelector('#terms-conditions');
    const checkoutButton = document.querySelector('button[name="checkout"]');


    if (termsOfServiceCheckbox) {
        termsOfServiceCheckbox.addEventListener('change', function() {

            if (this.checked) {
                checkoutButton.removeAttribute('disabled');
            } else {
                checkoutButton.setAttribute('disabled', 'disabled');
            }
        });
    }

})


















// Add set to cart button - Quantity added = set quantity

// let button = document.querySelector('button[data-action="add-to-cart-set"]');

// if (button) {
//     button.addEventListener('click', function(e) {
//         e.preventDefault();
        
//         let setQuantity = this.dataset.setQuantity;
    
//         let form = this.closest('form');
    
//         form.querySelector('input[name="quantity"]').value = setQuantity;
        
//         form.submit();
//     })    
// }


//   fetch(window.Shopify.routes.root + 'cart/update.js', {
//     method: "POST",
//     headers: {
//       'Content-Type': 'application/json'
//     },
//     body: JSON.stringify({
//       [productVariantId]: parsedQuantity,
//       [installationProductVariantId]: 0
//     })
//   })
//   .then(response => response.json());
